import React, { useEffect, useState } from 'react'
import TitlebarInner from './TitlebarInner'
import axios from 'axios';
import { Link } from 'react-router-dom';
import FooterPage from './FooterPage';
  
  export default function BlogPage() {

    const [blogdata, setblogdata] = useState(null);

    useEffect(() =>  {
        axios.get('https://cleverotech.com/blogs/blogs.json')
          .then(response => {
            setblogdata(response.data);
          })
          .catch(error => console.error('Error fetching data:', error));
      },[blogdata]);

  return (
    <>
        <TitlebarInner key="blog" PageName="Blog" PageDec="We harness the tools of traditional and digital." />
        <main className="content bg-top-center bg-cover blog-background-image" id="lqd-site-content">
            <div id="lqd-contents-wrap">
                <section className="lqd-section blog py-80" id="blog">
                    <div className="container">
                        <div className="row">
                            <div className="col col-12">
                                <div className="row -mx-15">
                                    {
                                        blogdata?.blogs?.map((data,ind)=>{
                                            return(
                                            <div className="col col-sm-6 col-lg-4 mb-30 px-15 py-0">
                                                <Link to={`/blog/${data.title.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/:/g, '')}`}>
                                                    <article className="lqd-lp relative lqd-lp-style-6 lqd-lp-hover-img-zoom lqd-lp-animate-onhover rounded-4 overflow-hidden text-start post type-post status-publish format-standard has-post-thumbnail hentry category-blog-single tag-beauty tag-travel">
                                                        <div className="lqd-lp-img overflow-hidden">
                                                            <figure>
                                                                <img width="720" height="510" src={data.src} alt="modernagencywp"/>
                                                            </figure>
                                                            <div className="lqd-lp-meta uppercase font-bold relative z-3">
                                                                <span className="screen-reader-text">Tags</span>
                                                                <ul className="lqd-lp-cat lqd-lp-cat-shaped lqd-lp-cat-solid reset-ul inline-ul font-bold uppercase tracking-0/1em">
                                                                    <li>
                                                                        <a className="rounded-full" href="#" rel="category">Blog Single</a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <header className="lqd-lp-header p-2rem">
                                                            <h2 className="entry-title lqd-lp-title mt-1rem mb-0 h5">
                                                                <a className="text-black" rel="bookmark">{data.title}</a>
                                                            </h2>
                                                        </header>
                                                        
                                                    </article>
                                                </Link>
                                            </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
        <FooterPage/>
    </>
  )
}